// extracted by mini-css-extract-plugin
export default {"currencyInput":"CurrencyInput_currencyInput__OKqtz"};